import { render, staticRenderFns } from "./PageSlides.vue?vue&type=template&id=11aa7d98&scoped=true&"
import script from "./PageSlides.vue?vue&type=script&lang=js&"
export * from "./PageSlides.vue?vue&type=script&lang=js&"
import style0 from "./PageSlides.vue?vue&type=style&index=0&id=11aa7d98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11aa7d98",
  null
  
)

export default component.exports